import { FC, useEffect, useState } from "react";
import { Modal, ModalHeading } from "@sainsburys-tech/luna-modal";
import { AddPopupType } from "../../../../Interfaces/IAddFieldModalProps";
import "../../Edit-FamilyGroup/familyGroupModalEdit.scss";
import FamilyGroupManagementEdit from "./familyGroupManagementFields";
import { useSelector } from "react-redux";
import { endpoints } from "../../../../ApiEndPoints/apiEndPoints";
import { useGetApi } from "../../../../Redux/Hooks/useGetApi";
import LoadingIndicator from "../../../Loading";
import {
  ButtonGroupPrimary,
  ButtonGroupWrapper,
  OutlinedButton,
} from "@sainsburys-tech/luna-button";
import * as Constants from "../../../../Constants/index";

const EditFieldModal: FC<AddPopupType> = ({
  isOpen,
  handleClose,
  handleAddCallback: handleAdd,
  title,
}) => {
  const [message, setMessage] = useState<string>();
  const payload = useSelector((state: any) => state.popupReducer);

  let params = {
    service: endpoints.getProductData(),
    skip: undefined,
    take: 0,
    isEnabled: true,
    filter: encodeURIComponent(
      `tolower(FamilyGroup) eq '${payload.data.editPayload.values.FamilyGroup?.toLowerCase()}' and ProductType eq ${
        payload.data.editPayload.values.ProductType == null
          ? null
          : `'${payload.data.editPayload.values.ProductType}'`
      }`
    ),
    refetchOnWindowFocus: false,
    isPaginationRequired: true,
  };

  const {
    data: apiResponse,
    isLoading,
    refetch,
    isSuccess,
  } = useGetApi(params);

  useEffect(() => {
    if (
      apiResponse !== undefined &&
      apiResponse?.response !== undefined &&
      apiResponse?.response?.status !== 200
    ) {
      let text = `Product service returned response code "${apiResponse.response.status}", as of now can't edit ${payload.data.editPayload.values.FamilyGroup}\n please try again after sometime.`;
      setMessage(text);
    } else if (
      isSuccess &&
      (apiResponse?.status === 200 ||
        (apiResponse?.response?.status === 200 &&
          apiResponse?.response !== undefined)) &&
      apiResponse !== undefined &&
      apiResponse?.data?.value?.length > 0
    ) {
      let text = `Family Group '${payload.data.editPayload.values.FamilyGroup}' with ProductType '${payload.data.editPayload.values.ProductType}' associated with ${apiResponse?.data["@odata.count"]} Products.\n You cannot edit this.`;
      setMessage(text);
    } else if (!isLoading) {
    }
  }, [apiResponse, isLoading, isSuccess]);

  const closeHandler = () => {
    handleClose(false);
  };
  return (
    <>
      {isLoading && <LoadingIndicator />}
      {isSuccess && !isLoading && (
        <div className={message ? "" : "familyGroupModal"}>
          <Modal
            small
            handleClose={() => closeHandler()}
            open={isOpen}
            headingId="info-modal"
            stickyHeader="Sticky Header"
            restrictClose={true}
            className={message ? "modal" : ""}
          >
            {isSuccess && message ? (
              <div>
                <ModalHeading element="h5">{message}</ModalHeading>
                <ButtonGroupWrapper actionbar>
                  <ButtonGroupPrimary>
                    <OutlinedButton
                      className="ln-u-margin-right"
                      onClick={() => handleClose(false)}
                    >
                      Cancel
                    </OutlinedButton>
                  </ButtonGroupPrimary>
                </ButtonGroupWrapper>
              </div>
            ) : (
              <FamilyGroupManagementEdit
                closeModal={closeHandler}
                isEdit={true}
                title={"Edit Family Group"}
              />
            )}
          </Modal>
        </div>
      )}
    </>
  );
};

export default EditFieldModal;